// src/components/Dashboard/SalesChart.js
import { Card, CardContent, Typography } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

function SalesChart({ data }) {
  return (
    <Card
      sx={{
        boxShadow: '0 4px 20px rgba(128, 0, 128, 0.3)',
        borderRadius: '12px',
        p: 2
      }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Satış Grafiği
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="satış"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
            />
            <Line type="monotone" dataKey="kar" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}

export default SalesChart;
